import { createTheme } from '../theme';
import {} from '../../DragDrop/components/Draggable/augmentation';

const theme = createTheme({
  components: {
    Draggable: {},
  },
});

export default theme.components;
